"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTopBar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledTopBar = styled_components_1.default.div `
  align-items: center;
  background: ${config_1.colors.sidewalk};
  display: flex;
  flex-direction: column;
  height: 140px;
  justify-content: space-between;

  @media ${config_1.device.tablet} {
    flex-direction: row;
    height: 70px;
  }
`;
